import { components } from "@appretio/api";

export type TemporalContext = components["schemas"]["TemporalContext"];
export type TemporalContextField = keyof TemporalContext;
export type TemporalContextOption<T extends TemporalContextField> =
  T extends "week_from"
    ? components["schemas"]["TemporalContext"]["week_from"]
    : T extends "week_to"
      ? components["schemas"]["TemporalContext"]["week_to"]
      : T extends "years"
        ? components["schemas"]["TemporalContext"]["years"]
        : T extends "aggregation_value"
          ? components["schemas"]["TemporalContext"]["aggregation_value"]
          : T extends "week_zero"
            ? components["schemas"]["WeekZeroEnum"]
            : never;

export type TemporalConfig = {
  label: string;
  options: {
    label: string;
    value: TemporalContextOption<TemporalContextField>;
  }[];
  multi?: boolean;
};

const endYear = new Date().getFullYear() + 3;

export const temporalConfig: Record<TemporalContextField, TemporalConfig> = {
  week_from: {
    label: "Week From",
    options: Array.from({ length: 52 }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    }))
  },
  week_to: {
    label: "Week To",
    options: Array.from({ length: 52 }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    }))
  },
  years: {
    label: "Year",
    options: Array.from({ length: 7 }, (_, i) => ({
      label: `${endYear - 7 + i}`,
      value: endYear - 7 + i
    })),
    multi: true
  },
  aggregation_value: {
    label: "Normalization",
    options: [
      { label: "4 weeks", value: 4 },
      { label: "8 weeks", value: 8 },
      { label: "Cumulative", value: "cumulative" },
      { label: "Lifetime", value: "lifetime" }
    ]
  },
  week_zero: {
    label: "Metric",
    options: [
      { label: "1st distribution", value: "DISTRIBUTION" },
      { label: "1st go-live", value: "GO_LIVE_WEEK" },
      { label: "1st sales", value: "SALES" }
    ]
  }
};
